import React from 'react';
import classnames from 'classnames';
import { PapiEditorText } from '@wix/da-types-papi';
import CustomBoxViewer from '@wix/da-shared-react/pkg/DaEditorWrapper/Viewer/CustomBox';
import TextRenderer from '@wix/da-shared-react/pkg/TextRenderer';
import Background from '@wix/da-shared-react/pkg/Background';
import { BackgroundInfo } from '@wix/da-shared-react/pkg/Background/types';
import {
  MeasuredContainer,
  MeasuredCookieType,
  MeasuredInjectedProps,
} from '@wix/da-shared-react/pkg/Measured';
import s from './Custom.scss';

export interface Props extends BackgroundInfo {
  className?: string;
  title?: string;
  customtext: PapiEditorText;
  moduleId: number;
  moduleVersion: number;
  isCurrentUserCoreMember: boolean;
}
const Custom: React.FC<Props> = props => {
  const {
    title,
    imageDeviation,
    backgroundType,
    imageDisplayMode,
    imageTint,
    pattern,
    gradient,
    color,
  } = props;
  const backgroundProps = {
    title,
    imageDeviation,
    backgroundType,
    imageDisplayMode,
    imageTint,
    pattern,
    gradient,
    color,
  };
  return (
    <MeasuredContainer
      cookieType={MeasuredCookieType.USER_PROFILE_CUSTOM}
      cookieDim="width"
      listenOnWindow
    >
      {(measuredProps: MeasuredInjectedProps) => {
        const width =
          (measuredProps.container && measuredProps.container.width) || 600;

        return (
          <Background
            variant="custombox"
            className={classnames(
              'da-editor-custombox',
              s['root'],
              props.className
            )}
            contentClassName={s['content']}
            {...backgroundProps}
          >
            <div style={{ width: '100%' }} ref={measuredProps.onRef}>
              <TextRenderer
                width={width}
                textContent={props.customtext}
                reactViewer={CustomBoxViewer}
                legacyTheme={'default'}
                viewerKey={`custombox-${props.moduleId}-${props.moduleVersion}`}
              />
            </div>
          </Background>
        );
      }}
    </MeasuredContainer>
  );
};
Custom.displayName = 'Custom';

export default Custom;
